import { useMemo } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import {
  formatDate,
  formatDuration,
  formatNumber,
  formatPercent,
} from "../lib/format";

/** Форматтеры, привязанные к текущему языку интерфейса. */
export function useFormat() {
  const { language } = useLanguage();
  return useMemo(
    () => ({
      language,
      number: (v: number | null | undefined, max = 2) =>
        formatNumber(v, language, max),
      percent: (v: number | null | undefined, max = 0) =>
        formatPercent(v, language, max),
      date: (
        v: string | number | Date | null | undefined,
        o?: Intl.DateTimeFormatOptions,
      ) => formatDate(v, language, o),
      duration: formatDuration,
    }),
    [language],
  );
}
